export { default as AlertSVG } from './alert';
export { default as CheckCircleFillSVG } from './check-circle-fill-svg';
export { default as CheckboxCheckedSVG } from './checkbox-checked-svg';
export { default as CheckboxIndeterminateSVG } from './checkbox-indeterminate-svg';
export { default as EditSVG } from './edit-svg';
export { default as EyeOpenSVG } from './eye-open-svg';
export { default as EyeCloseSVG } from './eye-close-svg';
export { default as LogoutSVG } from './logout-svg';
export { default as PlusCircleSVG } from './plus-circle-svg';
export { default as ProfileSVG } from './profile-svg';
export { default as PrinterSVG } from './printer';
export { default as RefreshSVG } from './refresh-svg';
export { default as RoleSVG } from './role-svg';
export { default as SaveSVG } from './save';
export { default as TrashSVG } from './trash-svg';
export { default as CloseSVG } from './close-svg';
export { default as CloseCircle } from './circle-close';

export { default as ArrowLeftRightSVG } from './arrow-left-right-svg';
export { default as ArrowClockwiseSVG } from './arrow-clockwise-svg';
export { default as AeroplaneSVG } from './aeroplane-svg';
export { default as ArchiveSVG } from './archive-svg';
export { default as BankSVG } from './bank-svg';
export { default as BedSVG } from './bed-svg';
export { default as BellSVG } from './bell-svg';
export { default as BinocularSVG } from './binocular-svg';
export { default as BoatSVG } from './boat-svg';
export { default as CarSVG } from './car-svg';
export { default as CardHolderSVG } from './card-holder-svg';
export { default as CaretCircleDoubleUpSVG } from './caret-circle-double-up-svg';
export { default as ChartLineSVG } from './chart-line-svg';
export { default as CalendarXSVG } from './calendar-x-svg';
export { default as CheckCircleSVG } from './check-circle-svg';
export { default as NotePencilSVG } from './note-pencil-svg';
export { default as CircleDollarSVG } from './circle-dollar-svg';
export { default as CounterClockwiseSVG } from './counter-clockwise-svg';
export { default as DepositSVG } from './deposit-svg';
export { default as FilesSVG } from './files-svg';
export { default as FolderSimpleUserSVG } from './folder-simple-user-svg';
export { default as FoldersSVG } from './folders-svg';
export { default as GearSVG } from './gear-svg';
export { default as NoteSVG } from './note-svg';
export { default as IdentificationBadgeSVG } from './identification-badge-svg';
export { default as LockSVG } from './lock-svg';
export { default as OthersSVG } from './others-svg';
export { default as ReceiptSVG } from './receipt-svg';
export { default as ScrollSVG } from './scroll-svg';
export { default as SliderHorizontalSVG } from './slider-horizontal-svg';
export { default as SuitcaseSVG } from './suitcase-svg';
export { default as ShuffleSVG } from './shuffle-svg';
export { default as TagSVG } from './tag-svg';
export { default as UploadSVG } from './upload-svg';
export { default as UserSVG } from './user-svg';
export { default as UsersThreeSVG } from './users-three-svg';
export { default as UserSquareSVG } from './user-square-svg';
export { default as WalletSVG } from './wallet-svg';
export { default as WithdrawSVG } from './withdraw-svg';
export { default as XCircleSVG } from './x-circle-svg';
export { default as ApprovalSVG } from './approval-icon';
export { default as TrashBin } from './trashbin-svg';
export { default as DragIcon } from './drag-svg';
export { default as UpgradeIcon } from './upgrade-svg';
export { default as CaretDownIcon } from './caret-down-svg';
export { default as PaymentChannelIcon } from './payment-channel-svg';
export { default as ProjectSVG } from './project-svg';
export { default as PackageSVG } from './package-svg';
export { default as WalletClockwiseIcon } from './wallet-clockwise-svg';
export { default as BankClockwiseIcon } from './bank-clockwise-svg';
export { default as NotebookIcon } from './notebook-svg';
export { default as BroomIcon } from './broom-svg';

export { default as RefundAgentSVG } from './refund-agent-svg';
export { default as RefundReleaseSVG } from './refund-release-svg';
export { default as RefundUserSVG } from './refund-user-svg';
export { default as ExportSVG } from './export-svg';
export { default as DocumentCheckSVG } from './document-check-svg';
export { default as Receipt2SVG } from './receipt-2-svg';

export { default as AeroplaneDocSVG } from './aeroplane-doc-svg';
export { default as BankDocSVG } from './bank-doc-svg';
export { default as BedDocSVG } from './bed-doc-svg';
export { default as ChecksSVG } from './checks-svg';
export { default as DollarSVG } from './dollar-svg';
export { default as DollarTransactionSVG } from './dollar-transaction-svg';
export { default as ReceiptDocSVG } from './receipt-doc-svg';
export { default as ScrollDocSVG } from './scroll-doc-svg';
export { default as UserDocSVG } from './user-doc-svg';
export { default as UserDollarSVG } from './user-dollar-svg';
export { default as WalletDocSVG } from './wallet-doc-svg';
export { default as ClockSVG } from './clock-svg';
export { default as DownloadSVG } from './download-svg';
export { default as CircleSVG } from './circle-svg';
export { default as ArticlePencilSVG } from './article-pencil-svg';
export { default as SquareFourSVG } from './square-four-svg';
export { default as WarningCircleSVG } from './warning-circle-svg';
export { default as InformationCircleSVG } from './information-circle-svg';
export { default as CopySVG } from './copy-svg';
